import { renderToString } from "react-dom/server";

import { combineConfigs, noMarkerConfig, tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import PieChartTooltip from "app/pages/app-intelligence/app-analysis/components/GenericGraph/components/PieChartTooltip";

import { getValueAsPercentage } from "../serp-composition/serpCompositionUtils";

export const getConfig = (hasNoData: boolean) =>
    combineConfigs({}, [
        noMarkerConfig,
        {
            chart: {
                // these 2 define the container size and the svg size
                height: "100%",
                width: 148,
                spacing: [0, 0, 0, 0],
            },
            plotOptions: {
                pie: {
                    // controls size of the pie
                    size: 148,
                    ...(hasNoData && {
                        fillColor: colorsPalettes.carbon[50],
                        borderWidth: 0,
                    }),
                },
            },
            tooltip: {
                enabled: true,
                followPointer: true,
                headerFormat: ``,
                ...tooltipContainerConfig().tooltip,
                pointFormatter() {
                    const name = this.name;
                    const color = this.color as string;
                    const percent = getValueAsPercentage(this.y);

                    const props = {
                        name,
                        color,
                        value: percent,
                    };

                    return renderToString(<PieChartTooltip {...props} />);
                },
            },
        },
    ]);
